query GetRoles {
  roles {
    id
    name
    permissions {
      id
      name
    }
  }
}
